export default function SidebarRight({ show, children }) {
  return <div className={"right-sidebar " + (show ? "show" : "hide")}>{children}</div>;
}
